module.exports = __webpack_public_path__ + "img/banktransfer.e546d97e.svg";